import {
  IUserCreateProps,
  IUserProps,
  IUserSimpleProps,
  IUserUpdateParams,
} from './types';
import { api } from '../DefaultService';
import { IPaginationParams } from '../types';

const ENDPOINT = 'v1/user';

export const createUserAsync = async (
  data: IUserCreateProps,
): Promise<IUserProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getUserByIdAsync = async (id: string): Promise<IUserProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllUserByLicenseAsync = async (
  pagination?: IPaginationParams,
): Promise<IUserSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, { params: pagination })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
export const getAllUsersByLicenseCountAsync = async (): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateUserAsync = async ({
  id,
  data,
}: IUserUpdateParams): Promise<IUserProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteUserAsync = async (id: string): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
